import api from "../../api/api";

export const getRolloverPreview = async (tc_id, roll_over_tc_id, signal) => {
  const response = await api.get("/docs/rolloverPreview", {
    params: { tc_id, roll_over_tc_id },
    signal,
  });
  // The shared API interceptor already unwraps the Axios response.
  return response.data;
};
